module.exports = "<div class='container-fluid'>\r\n  <div class='row'>\r\n    <div class='col-sm-9 body-content'>\r\n      {{title}}\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/date-picker/datepicker.component.html
// module id = ./src/app/shared/date-picker/datepicker.component.html
// module chunks = main